import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form';
import {
    Button,
    Typography,
    Spinner,
    Card,
} from "@material-tailwind/react";

import { ToastContainer, toast } from 'react-toastify';
import AIcon from '../../components/partials/AIcon';
import { useShared } from '../../hooks/useShared';
import UploadPhoto from '../../components/upload/UploadPhoto';
import ABreadcrumbs from '../../components/breadcrumbs/ABreadcrumbs';
import AInput from '../../components/fields/AInput';
import ASelect from '../../components/fields/ASelect';
import ASwitch from '../../components/fields/ASwitch';
import {useParams } from 'react-router-dom';
import APDate from '../../components/fields/APDate';


const userFields = [

    { label: 'نقش کاربر / کارمند', name: 'roles', type: 'select', roles: [1], icon: null, className: '', required: 'Please select role for the user', options: [], isMulti: true, hide: false },
    { label: 'اسم', name: 'fname', type: 'text', roles: [1], icon: 'person-outline', className: '', required: 'Please enter first name address', isStyle: false, hide: false },
    { label: 'تخلص', name: 'lname', type: 'text', roles: [1], icon: 'person-outline', className: '', required: false, isStyle: false, hide: false },
    { label: 'نام پدر', name: 'father_name', type: 'text', roles: [1], icon: 'person-outline', className: '', required: false, isStyle: false, hide: false },
    { label: 'ايمیل', name: 'email', type: 'email', roles: [1], icon: 'at-outline', className: '', required: "Please enter email address of the employee", isStyle: false, hide: false },
    { label: 'شماره تماس', name: 'phone', type: 'text', roles: [1], icon: 'call-outline', className: '', isStyle: false, hide: false, required: 'Please enter phone number of the employee' },
    {
        label: 'مقام', name: 'position', type: 'select', roles: [1], icon: 'call-outline', className: '', isStyle: false, hide: true, options: [], isMulti:true,
        required: 'Please select a position for the employee',
    },
    { label: 'معاش به افغانی', name: 'salary', type: 'text', roles: [1], icon: 'wallet-outline', className: '', isStyle: false, hide: true },
    { label: 'زون', name: 'zone', type: 'select', roles: [1], icon: 'call-outline', className: '', isStyle: false, hide: true, options: [], required: 'Please select a zone for the employee', },
    { label: 'تاریخ عضویت', name: 'joining_date', type: 'pdate', roles: [1], icon: 'call-outline', className: '', isStyle: false, hide: true, options: [], required: false, },
    { label: 'پاسورد', name: 'password', type: 'password', roles: [1], icon: 'eye-outline', className: '', isStyle: false, hide: false },
    { label: 'حالت', name: 'status', type: 'switch', roles: [1], icon: 'book-outline', className: '', required: false, hide: false, value: 1 },
    { label: 'ادرس', name: 'home_address', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false, isDisabled: false, hide: false },
    { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false, hide: false },
    { label: 'عکس', name: 'photo', type: 'photo', roles: [1], icon: 'book-outline', className: '', hide: false },
]



export default function NewUser({ v }) {
    const { id } = useParams();
    const { http,auth, com, roles, photo, setPhoto, setModel, navigate, uploadPhoto, location, consts, fetchModelCounts } = useShared();

    useEffect(() => {
        if (!auth.hasRole([1,2,21,22])) {
            return navigate("/db/notAllowed")
        }
      }, [])

    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)
    const [fields, setFields] = useState([...userFields])
    const [userType, setUserType] = useState(location?.state?.user_type)

    const { register, handleSubmit, control, formState: { errors }, watch, reset, setValue } = useForm({});

    console.log('location ', location)


    useEffect(() => {
        if (id > 0) {

            setModel(null)
            setLoading(true)
            http.get(`/api/users/${id}`).then(res => {
                console.log('get model ', res);
                if (res.data.success && res.data.data) {
                    const data = res.data.data;
                    reset(data)
                    setModel(data)
                    const img = data?.image_data?.path
                    setPhoto({ url: img ? consts.BASE_URL + img : '', photo: null })

                }
                setLoading(false)

            }, err => {
                console.log('err');
                setLoading(false)
            })
        } else {
            setValue('status', 1)
        }
        // Get positions list
        getCategories(6, { value: 1, name_af: 'name_af' })
        getZones(8, { nameId: true })

    }, [])

    useEffect(() => {
        //show employee related input fields => position, salary
        if (userType?.value === 2) {
            console.log("user type change ", userType);
            fields[6].hide = false
            fields[7].hide = false
            fields[8].hide = false
            fields[9].hide = false
            setFields([...fields])
        } else {
            fields[6].hide = true
            fields[7].hide = true
            fields[8].hide = true
            fields[9].hide = true
            setFields([...fields])
        }
    }, [userType])


    const getRoles = async () => {
        if (roles.length > 0) {
            userFields.map(f => {
                if (f.name === 'roles') f.options = [...roles]
            })
            await setFields(pre => userFields)
        }

    }
    useEffect(() => {
        console.log("Get user roles", roles)
        getRoles()
    }, [roles])


    const getCategories = (index, type) => {
        console.log("getCategories");
        setLoading(true)
        const res = http.post('api/categoryAdvanceSearch', type).then(res => {
            console.log("categoryAdvanceSearch archive ", res);
            if (res.data.success) {
                setLoading(pre => ({ ...pre, show: false }))
                const data = res.data?.data;
                userFields[index].options = data
                setFields(userFields)
                setLoading(false)
            }
        }, err => {
            setLoading(false)
            console.log('getCategories archive error ', err);
        })


    }

    const getZones = (index, type) => {
        console.log("getZones");
        setLoading(true)
        const res = http.post('api/zonesAdvanceSearch', type).then(res => {
            console.log("czonesAdvanceSearch", res);
            if (res.data.success) {
                setLoading(pre => ({ ...pre, show: false }))
                const data = res.data?.data;
                userFields[index].options = data
                setFields(userFields)
                setLoading(false)
            }
        }, err => {
            setLoading(false)
            console.log('getCategories archive error ', err);
        })


    }

    const mReset = () => {
        reset({})
    }




    const submit = async (data) => {
        setErrorMessage(null)

        //password confirmatin not required
        data['no_pass_confirmation'] = true

        // set user type 
        data["user_type"] = userType

        console.log('submit ', data);
        try {
            setLoading(true)
            const res = await http.post('api/users', data);
            console.log('user ', res);
            if (res.data?.success) {
                mReset()
                const user = res.data?.data;
                if (user?.id && photo) {
                    console.log(user)
                    uploadPhoto(user?.attachment).then(res => {
                        console.log("uploadPhoto ", res)
                        //setPhoto(null)
                    });
                }
                toast.success(res.data.message);
                fetchModelCounts()
                navigate(-1)
            }

            setLoading(false)


        } catch (error) {
            setLoading(false)
            const err = error?.response?.data
            if (!err?.success) {
                setErrorMessage(err.message)
                toast.error(err.message);
            }
        }

    }



    return (
        <>
            <ABreadcrumbs links={[
            { name: userType?.value === 2?"کارمندان":"کاربران", link:userType?.value === 2?"/users/employees/0":"/users/usrs" },
             { name: userType?.value === 2?"کارمند جديد":"کاربر جديد", link: '/users/new_user/0' }]} />
            <div className='md:flex  items-start gap-4'>

                <Card className="w-full md:w-[70%]  p-2 md:p-4 mt-4 relative">

                    <form className=" flex flex-col gap-4 mt-4" onSubmit={handleSubmit(submit)}>
                        <div className=" grid  gap-6 items-baseline">

                            <div className='grid md:grid-cols-1 gap-4'>
                                {/*  <ASelect v={{ register, errors, control, data: newModelInputFields[0] }} onChange={(e) => handleUserType(e)} /> */}
                                <fieldset className='border p-3 rounded-lg grid gap-4'>
                                    <legend className='font-bold text-main-color'>معلومات {userType?.value === 2?'کارمند':'کاربر'} جديد</legend>
                                    {
                                        fields?.map((data, i) => {
                                            return (
                                                <React.Fragment key={i}>
                                                    {
                                                        data?.type === 'text' || data.type === 'date' || data?.type === 'textarea' || data?.type === 'password' || data?.type === 'email' ?
                                                            <AInput v={{ register, errors, data }} />
                                                            : data?.type === 'select' ? <ASelect v={{ register, errors, control, data }} />
                                                                : data?.name === 'position' && !data?.hide ? <ASelect v={{ register, errors, control, data }} />
                                                                    : data?.type === 'switch' ? <ASwitch v={{ register, errors, data }} />
                                                                    : data?.type === 'pdate' ? <APDate v={{ register, errors, control, setValue, data }} />

                                                                        : null
                                                    }
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                    <UploadPhoto v={{ obj: location?.state?.model?.image_data, className: "md:hidden ", title: 'Upload photo' }} />
                                </fieldset>
                            </div>
                        </div>
                        {errorMessage && <Typography
                            variant="small"
                            color="gray"
                            className="flex items-center text-red-500 gap-2 font-normal "
                        >
                            <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                            {errorMessage}
                        </Typography>}
                        <div className='flex gap-4 md:justify-end'>
                            <Button className="btn1 w-full md:w-[10%]" size='sm' type="submit" disabled={loading}>  {loading ? <Spinner color="teal" className="h-4 w-4" /> : "ارسال"}    </Button>
                            <Button variant="outlined" size='sm' color="gray" onClick={() => mReset()}>Reset</Button>
                        </div>
                    </form>
                </Card>
                <UploadPhoto v={{ obj: location?.state?.model?.image_data, title: 'Upload photo', className: "hidden md:block w-full  md:w-[30%]  p-2 md:p-4  relative" }} />
            </div>
            <ToastContainer />
        </>
    )

}